import {useViewer} from '../state/viewer/hooks';
import {Viewer} from '../state/viewer/types';
import {useAccountTeamsList} from './HomePage/HomePageSidebar/useAccountTeamsList';

// TODO: Same value as QuickStartWeavePlayground.tsx, should we explicitly reuse?
export const DEFAULT_PROJECT_NAME = 'quickstart_playground';

// TODO: These function copied from QuickStart.tsx could be deduplicated.
export const useSelectedAccountDefaultEntity = (): string | null => {
  // Returns the first (default) team in the selected account.
  const {accountTeams} = useAccountTeamsList();
  const teams = accountTeams?.edges?.map(team => team?.node) ?? [];
  const firstTeamInSelectedAccount = teams.length > 0 ? teams[0]?.name : null;
  return firstTeamInSelectedAccount;
};

export const useUserSpecifiedDefaultEntity = (): string | null => {
  // Returns the default entity name from the viewer's account.
  // This is slightly legacy behavior particularly for personal accounts.
  const viewer: Viewer | undefined = useViewer();
  return viewer?.defaultEntity?.name ?? null;
};
